module.exports = __webpack_public_path__ + "img/unselected.svg.9ba050ec.svg";